<template>
  <v-btn v-bind="$attrs" color="error" @click="$router.go(-1)">
    {{ $t('buttons.back') }}
  </v-btn>
</template>

<script>
export default {
  name: 'BackButton',
}
</script>
